import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import PropTypes from "prop-types";
import colorList from "./colorsList";
import "./multiLine.scss";

class MultiLine extends Component {
  componentDidMount() {
    const { lineStyle, circleStyle, id, data, width } = this.props;
    this.displayChart({ lineStyle, circleStyle, id, data, width, colorList });
  }

  componentWillReceiveProps(nextProps) {
    const { lineStyle, circleStyle, id, data, width } = nextProps;
    if (
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data) ||
      nextProps.width !== this.props.width
    ) {
      $(`#${this.props.id}`).empty();
      this.displayChart({ lineStyle, circleStyle, id, data, width, colorList });
    }
  }

  displayChart = ({ lineStyle, circleStyle, id, data, width, colorList }) => {
    if (data) var Data = data;
    Data.forEach(function (el) {
      el.Data = el.data.sort((a, b) => a[0] - b[0]);
    });

    var height = 300;
    var margin = 50;
    var duration = 500;

    var lineOpacity = "0.35";
    var lineOpacityHover = "0.85";
    var otherLinesOpacityHover = "0.1";
    var lineStroke = "3px";
    var lineStrokeHover = "2px";

    var circleOpacity = "0.85";
    var circleOpacityOnLineHover = "0.25";
    var circleRadius = 3;
    var circleRadiusHover = 6;

    var date = [],
      val = [];
    for (var i in Data) {
      let x = Data[i]["data"];
      let y = Data[i]["name"];
      for (var j in x) {
        date.push(x[j][0]);
        val.push(x[j][1]);
      }
    }
    var ext2 = d3.extent(val);
    var ext1 = d3.extent(date);

    // format date
    Data.map((d) => {
      d.Data.map((d) => {
        d.date = d[0];
        d.price = +d[1];
      });
    });

    // scales
    var xScale = d3.time
      .scale()
      .domain(ext1)
      .range([0, width - margin]);

    var yScale = d3.scale
      .linear()
      .domain([0, ext2[1]])
      .range([height - margin, 0]);

    var colors = d3.scale.ordinal().range(colorList);

    var svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", width + margin + "px")
      .attr("height", height + margin + "px")
      .append("g")
      .attr("transform", `translate(${margin}, ${margin})`);

    var line = d3.svg
      .line()
      .x((d) => xScale(d.date))
      .y((d) => yScale(d.price));

    let lines = svg.append("g").attr("class", "lines");

    lines
      .selectAll(".line-group")
      .data(Data)
      .enter()
      .append("g")
      .attr("class", "line-group")
      .on("mouseover", function (d, i) {
        svg
          .append("text")
          .attr("class", "title-text")
          .style("fill", colors(i))
          .text(d.name)
          .attr("text-anchor", "middle")
          .attr("x", (width - margin) / 2)
          .attr("y", 5)
          .style("fill", "none");
      })
      .on("mouseout", (d) => {
        svg.select(".title-text").remove();
      })
      .append("path")
      .attr("class", `${lineStyle}`)
      .attr("d", (d) => line(d.Data))
      .style("stroke", (d, i) => colors(i))
      .style("opacity", lineOpacity)
      .style("fill", "none")
      .on("mouseover", function (d) {
        d3.selectAll(`.${lineStyle}`)
          .style("opacity", otherLinesOpacityHover)
          .transition()
          .duration(duration);
        d3.selectAll(`.${circleStyle}`).style(
          "opacity",
          circleOpacityOnLineHover
        );
        d3.select(this)
          .style("opacity", lineOpacityHover)
          .style("stroke-width", lineStrokeHover)
          .style("cursor", "pointer");
      })
      .on("mouseout", function (d) {
        d3.selectAll(`.${lineStyle}`).style("opacity", lineOpacity);
        d3.selectAll(`.${circleStyle}`).style("opacity", circleOpacity);
        d3.select(this)
          .style("stroke-width", lineStroke)
          .style("cursor", "none")
          .style("fill", "none");
      });
    // adding circle on the line
    lines
      .selectAll("circle-group")
      .data(Data)
      .enter()
      .append("g")
      .style("fill", (d, i) => colors(i))
      .selectAll("circle")
      .data((d) => d.data)
      .enter()
      .append("g")
      .attr("class", `.${circleStyle}`)
      .on("mouseover", function (d) {
        d3.select(this)
          .style("cursor", "pointer")
          .append("text")
          .attr("class", "text")
          .text(`${d.price.toFixed(2)}`)
          .attr("x", (d) => xScale(d.date) + 5)
          .attr("y", (d) => yScale(d.price) - 10);
      })
      .on("mouseout", function (d) {
        d3.select(this)
          .style("cursor", "none")
          .transition()
          .duration(duration)
          .selectAll(".text")
          .remove();
      })
      .append("circle")
      .attr("cx", (d) => xScale(d.date))
      .attr("cy", (d) => yScale(d.price))
      .attr("r", circleRadius)
      .style("opacity", circleOpacity)
      .on("mouseover", function (d) {
        d3.select(this)
          .transition()
          .duration(duration)
          .attr("r", circleRadiusHover);
      })
      .on("mouseout", function (d) {
        d3.select(this).transition().duration(duration).attr("r", circleRadius);
      });
    //   x and y axis
    var xAxis = d3.svg.axis().scale(xScale).orient("bottom");

    var yAxis = d3.svg.axis().scale(yScale).orient("left");

    svg
      .append("g")
      .attr("class", "axis")
      .attr("transform", `translate(0, ${height - margin})`)
      .call(xAxis);
    svg.append("g").attr("class", "axis").call(yAxis);
  };
  render() {
    return <div id={this.props.id} />;
  }
}

MultiLine.propTypes = {
  width: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  lineStyle: PropTypes.string.isRequired,
  circleStyle: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default MultiLine;



// WEBPACK FOOTER //
// ./src/components/d3Components/MultiLineChart/multiLine.jsx